<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    fill="none"
    version="1.1"
    width="16"
    height="16"
    viewBox="0 0 16 16"
  >
    <g style="mix-blend-mode: passthrough">
      <g style="mix-blend-mode: passthrough">
        <path
          d="M13,9C13,11.8,10.8,14,8,14C5.2,14,3,11.8,3,9L3,3C3,2.4,3.4,2,4,2C4.6,2,5,2.4,5,3L5,9C5,10.7,6.3,12,8,12C9.7,12,11,10.7,11,9L11,3C11,2.4,11.4,2,12,2C12.6,2,13,2.4,13,3L13,9ZM2,15.5C2,15.2,2.2,15,2.5,15L13.5,15C13.8,15,14,15.2,14,15.5C14,15.8,13.8,16,13.5,16L2.5,16C2.2,16,2,15.8,2,15.5Z"
          fill-rule="evenodd"
          fill="currentColor"
        />
      </g>
    </g>
  </svg>
</template>
<script lang="ts">
import type { DefineComponent } from 'vue'
export default {
  name: 'Underline',
} as DefineComponent
</script>
